import routeGenerator from '~/lib/api/routes';

export const mapBackendPath = (path: string): string => {
  const parts = path.trim().split('/').filter(Boolean);

  if (parts.length === 1) {
    return path;
  }

  if (parts[0] === 'property' && parts.length === 3) {
    return routeGenerator.property({ slug: parts[2], category: parts[1] });
  }

  if (parts.length === 2) {
    return routeGenerator.post({ slug: parts[1], category: parts[0] });
  }

  return path;
};
